import React from 'react';
import { Flex, Box, Heading, css, Link } from 'theme-ui';
import Reveal from '@solid-ui-components/Reveal';
import Divider from '@solid-ui-components/Divider';
import FlexImage from '@solid-ui-components/FlexImage';
import FlexContent from '@solid-ui-components/FlexContent';
import ContentText from '@solid-ui-components/ContentText';
import ContentImages from '@solid-ui-components/ContentImages';
import ContentButtons from '@solid-ui-components/ContentButtons';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';
import Icon from '@solid-ui-components/ContentIcon/ContentIcon';

const styles = {
  listItem: {
    alignItems: 'stretch',
    justifyContent: 'flex-start',
  },
  line: {
    position: 'absolute',
    bottom: '10px',
    left: '50%',
    width: '1px',
    height: (t) => `calc(100% - ${t.sizes.icon.md + 20}px)`,
    transform: 'translateX(-50%)',
    zIndex: 1,
    bg: 'omega',
  },
  number: {
    color: 'white',
    fontWeight: 'body',
    borderRadius: 'full',
    bg: 'alpha',
    size: 'icon.md',
    textAlign: 'center',
    p: 2,
    mb: 0,
  },
  buttonsWrapper: {
    display: 'flex',
    flexDirection: ['column', null, 'row'],
    alignItems: ['stretch', null, null, 'start', 'stretch'],
    gap: '16px',
    '& a': {
      ml: 0,
      mt: 0,
    },
  },
  buttonContainer: {
    backgroundColor: '#36BFFA',
    py: '13px',
    px: '16px',
    display: 'flex',
    gap: '8px',
    width: 'fit-content',
    borderRadius: '8px',
    textDecoration: 'none',
    transition: 'all 250ms ease',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#0086C9',
    },
    mx: [0, 'auto', 'auto', 'auto', 0],
  },
  button: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '30px',
    color: '#fff',
    m: 0,
  },
};

const FeaturesWithPhotoBlock07 = ({
  content: { text, images, collection, buttons },
  reverse,
  customButton = false,
}) => (
  <Box sx={{ position: 'relative' }}>
    <Flex
      sx={{
        alignItems: [null, 'center'],
        flexDirection: [
          reverse ? 'column-reverse' : 'column',
          'column-reverse',
          null,
          null,
          reverse ? 'row-reverse' : 'row',
        ],
        mx: [null, null, null, customButton ? 0 : -4],
        gap: customButton ? '30px' : 11,
      }}
    >
      <FlexImage {...(customButton ? { flexBasis: 1 } : {})} reverse={reverse}>
        <ContentImages
          content={{ images }}
          reverse={reverse}
          imagePosition='center'
        />
      </FlexImage>
      <FlexContent
        sx={customButton ? { minWidth: [null, null, null, null, '490px'] } : {}}
        reverse={reverse}
      >
        <Box sx={{ textAlign: ['left', 'center', 'center', 'center', 'left'] }}>
          <ContentText
            content={[
              {
                ...text[0],
                as: 'h1',
                variant: 'h2',
              },
              ...text.slice(1),
            ]}
          />
        </Box>
        {collection && !customButton && (
          <>
            <Divider space={3} />
            <Reveal
              effect={reverse ? 'fadeInRight' : 'fadeInLeft'}
              duration={1.5}
            >
              {collection.map(({ text }, index) => (
                <Flex key={`item-${index}`} sx={styles.listItem}>
                  <Box sx={{ position: 'relative', flexShrink: 0, mr: 4 }}>
                    <Heading variant='h4' as='div' sx={styles.number}>
                      {index + 1}
                    </Heading>
                    {index + 1 < collection.length && <Box sx={styles.line} />}
                  </Box>
                  <Box>
                    <ContentText content={text} />
                    {index + 1 < collection.length && <Divider space={3} />}
                  </Box>
                </Flex>
              ))}
            </Reveal>
          </>
        )}
        {buttons && (
          <>
            {customButton ? (
              <>
                <Divider space={4} />
                <Link
                  href={buttons[0].link}
                  sx={styles.buttonContainer}
                  target='_blank'
                  rel='noreferrer'
                >
                  <p css={css(styles.button)}>{buttons[0].text}</p>
                  <Icon content={collection[0].icon} size='xxs' mt={'5px'} />
                </Link>
              </>
            ) : (
              <>
                <Divider space={3} />
                <ContentButtons
                  content={buttons}
                  wrapperStyles={styles.buttonsWrapper}
                />
              </>
            )}
          </>
        )}
      </FlexContent>
    </Flex>
  </Box>
);

export default WithDefaultContent(FeaturesWithPhotoBlock07);
